import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialAppTriggerState } from "./initializes";
import type { AppTrigger } from "./types";

const appTriggerSlice = createSlice({
  name: "appTrigger",
  initialState: initialAppTriggerState,
  reducers: {
    setAppTrigger: (state: AppTrigger, action: PayloadAction<number[]>) => {},
  },
});

export const { setAppTrigger } = appTriggerSlice.actions;
export default appTriggerSlice.reducer;
